import { Grid, NavLink, Paper, Stack,  } from "@mantine/core";
import React from "react";
import { Link, Outlet } from "react-router-dom";

const RentPaid = () => {
  return (
    <div>
      <Grid>
        <Grid.Col md={3}>
          <Stack spacing="0">
          <NavLink to="./one" label="Room one"  component={Link} />
          <NavLink to="./two" label="Room two" component={Link} />
          <NavLink to="./three" label="Room three" component={Link} />
          <NavLink to="./foure" label="Room four" component={Link} />
          </Stack>
        </Grid.Col>
        <Grid.Col md={9}>
          <Paper radius="lg" p="xs" sx={theme => ({
            background: theme.colors.gray[0],
            height: "100%"
          })}>
          <Outlet />
          </Paper>
        </Grid.Col>
      </Grid>
    </div>
  );
};

export default RentPaid;
